if (!customElements.get('subscription-quick-add')) {
  customElements.define(
    'subscription-quick-add',
    class SubscriptionQuickAdd extends HTMLElement {
      connectedCallback() {
        this.variantSelect = this.querySelector('[data-subscription-variant-select]');
        this.form = this.closest('form');

        if (!this.variantSelect || !this.form) return;

        this.variantIdInput = this.form.querySelector('input[name="id"]');
        this.sellingPlanInput = this.form.querySelector('[data-subscription-selling-plan-input]');
        this.submitButton = this.form.querySelector('[data-subscription-submit-button]');
        this.buttonText = this.form.querySelector('[data-subscription-button-text]');
        this.productTitle = this.dataset.productTitle || '';
        this.priceBlock =
          this.closest('.card__content')?.querySelector('[data-subscription-price-block]') ||
          this.closest('.card-wrapper')?.querySelector('[data-subscription-price-block]');
        this.originalPrice = this.priceBlock?.querySelector('[data-subscription-price-original]');
        this.discountedPrice = this.priceBlock?.querySelector('[data-subscription-price-discounted]');
        this.moneyFormat = this.priceBlock?.dataset.moneyFormat || window.Shopify?.money_format || '${{amount}}';
        this.discountPercent = Number(this.priceBlock?.dataset.discountPercent || 15);

        this.variantSelect.addEventListener('change', this.onVariantChange.bind(this));
        this.syncSelectedVariant();
      }

      onVariantChange() {
        this.syncSelectedVariant();
      }

      syncSelectedVariant() {
        const selectedOption = this.variantSelect.selectedOptions[0];
        if (!selectedOption || !this.variantIdInput || !this.submitButton) return;

        const variantId = selectedOption.value;
        const sellingPlanId = selectedOption.dataset.sellingPlanId || '';
        const price = Number(selectedOption.dataset.price || 0);
        const isAvailable = selectedOption.dataset.available === 'true';
        const hasSellingPlan = sellingPlanId !== '';

        this.variantIdInput.value = variantId;
        this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = sellingPlanId;
          this.sellingPlanInput.disabled = !hasSellingPlan;
        }

        this.updatePrices(price);

        const isDisabled = !isAvailable || !hasSellingPlan;
        this.submitButton.toggleAttribute('disabled', isDisabled);

        if (this.buttonText) {
          if (!isAvailable) {
            this.buttonText.textContent = 'Sold Out';
          } else if (!hasSellingPlan) {
            this.buttonText.textContent = 'Unavailable';
          } else {
            this.buttonText.textContent = 'Subscribe';
          }
        }

        const variantTitle = selectedOption.textContent.trim();
        if (!isDisabled) {
          this.submitButton.setAttribute('aria-label', `Subscribe to ${this.productTitle} - ${variantTitle}`);
        } else if (!isAvailable) {
          this.submitButton.setAttribute('aria-label', `${variantTitle} is sold out`);
        } else {
          this.submitButton.setAttribute('aria-label', `${variantTitle} is unavailable for subscription`);
        }
      }

      updatePrices(price) {
        if (!this.originalPrice || !this.discountedPrice) return;

        const promoPercent = Number(this.priceBlock?.dataset.promoPercent || 0);
        if (promoPercent > 0) {
          const salePrice = price - Math.floor((price * promoPercent) / 100);
          const planPrice = price - Math.round((price * this.discountPercent) / 100);
          const stackedPrice = planPrice - Math.floor((planPrice * promoPercent) / 100);
          this.originalPrice.textContent = this.formatMoney(salePrice);
          this.discountedPrice.textContent = this.formatMoney(stackedPrice);
          return;
        }

        const discountedPrice = Math.round(price * ((100 - this.discountPercent) / 100));
        this.originalPrice.textContent = this.formatMoney(price);
        this.discountedPrice.textContent = this.formatMoney(discountedPrice);
      }

      formatMoney(cents) {
        const placeholderMatch = this.moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        const placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
        const number = Number(cents) || 0;

        const value = (() => {
          switch (placeholder) {
            case 'amount_no_decimals':
              return (number / 100).toFixed(0);
            case 'amount_with_comma_separator':
              return (number / 100)
                .toFixed(2)
                .replace('.', ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            case 'amount_no_decimals_with_comma_separator':
              return (number / 100)
                .toFixed(0)
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            case 'amount_with_apostrophe_separator':
              return (number / 100)
                .toFixed(2)
                .replace('.', ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, "'");
            default:
              return (number / 100).toFixed(2);
          }
        })();

        return placeholderMatch ? this.moneyFormat.replace(placeholderMatch[0], value) : value;
      }
    }
  );
}
